// Libraries
import {
  Component,
  OnDestroy,
  OnInit,
  ElementRef,
  Renderer
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
}  from '@angular/forms';

// Services
import { GlobalSearchService } from './global-search.service';

// Models
import { GlobalSearch } from './../../../shared/models/global-search.interface';

/**
 * `GlobalSearchComponent` implements a view to global search
 */
@Component({
  selector: '[she-global-search]',
  template: require('./global-search.component.html'),
  styles: [require('./global-search.component.scss')]
})
export class GlobalSearchComponent implements OnDestroy, OnInit {
  /**
   * List of extinguisher or positions
   */
  public dataSearch: GlobalSearch[];
  /**
   * From group for global search.
   */
  public globalSearchForm: FormGroup;
  /**
   * Is search position or object
   */
  public isRunning: boolean;
  /**
   * Dropdown visibility
   */
  public isVisible = false;
  /**
   * Debounce time
   */
  private debounceTime = 500;
  /**
   * Global search
   */
  private query: any;
  /**
   * Global listener
   */
  private listener: any;

  /**
   * Creates a new `GlobalSearchComponent` instance.
   */
  constructor(
    private fb: FormBuilder,
    private globalSearchService: GlobalSearchService,
    private renderer: Renderer,
    private elementRef: ElementRef
  ) {
  }

  /**
   * Implements on init mehotd
   */
  public ngOnInit() {
    // Listen document events
    this.listener = this.renderer.listenGlobal('document', 'click', (event: any) => this.handleClick(event));
    // Build form
    this.buildForm();
  }

  /**
   * Implements on destroy method
   */
  public ngOnDestroy() {
    // If there is a globa listener, call listening
    if (this.listener) {
        this.listener();
    }
  }

  /**
   * Global search has no results
   */
  public notResults(): boolean {
    return this.dataSearch && this.globalSearchForm.get('query').value !== '' &&
           this.dataSearch.length === 0 && !this.isRunning;
  }

  /**
   * Clear global search.
   */
  public clear(): void {
    this.dataSearch = [];
    this.globalSearchForm.setValue({ query: '' });
    this.isRunning = false;
  }

  /**
   * Handles user click event
   * @param  {any} event Any event which ocurred
   */
  public handleClick(event: any): void {
    // Check if is click outside
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isVisible = false;
    } else {
      this.isVisible = event.target.tagName.toUpperCase() === 'INPUT';
    }
  }

  /**
   * Create form group and controls
   */
  private buildForm(): void {
    this.globalSearchForm = this.fb.group({
      'query': ['']
    });

    this.globalSearchForm.get('query').valueChanges.subscribe(() => {
      this.isRunning = true;
    });

    this.globalSearchForm.get('query').valueChanges
      .debounceTime(this.debounceTime)
      .subscribe(data => {
        if (data) {
          this.query = data;
          // Get all objects and positions
          this.all();
          this.isVisible = true;
        } else {
          // Clear data
          this.dataSearch = [];
          this.isRunning = false;
          this.isVisible = true;
        }
      });
  }

  /**
   * Make request to get all object or positions.
   */
  private all(): void {
    this.isRunning = true;
    // Make request
    this.globalSearchService.get(this.getParams())
      .then((data) => {
        this.isRunning = false;
        // Save data
        this.dataSearch = data;
      })
      .catch(() => {
        this.isRunning = false;
        // Clear data
        this.dataSearch = [];
      });
  }

  /**
   * Generate query params for request.
   * @return Query params
   */
  private getParams(): any {
    let params = {
      query: this.query
    };
    return params;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/layout/navbar/global-search/global-search.component.ts